import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vue from 'vue';
import App from './components/App'
import router from './router.js'
import { BFormFile } from 'bootstrap-vue'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import localization from "./localization/cz.json";
import localizationEN from "./localization/en.json";
import localizationDE from "./localization/de.json";
import VueI18n from "vue-i18n";

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}
miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
Vue.component('b-form-file', BFormFile)
Vue.use(VueNotifications, options)

// vyplnění lokalizací
const messages = {
    cz: localization,
    en: localizationEN,
    de: localizationDE
}
// registrace vuei18n
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: document.documentElement.lang, // nastavení lokalizace (cz,de,en) - přebíraná z index.html lang
    fallbackLocale: 'en',
    messages
})
  
new Vue({
    render: h => h(App),
    i18n,
    router,
}).$mount('#app');
